class Guide {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  event(){
    const slides = document.querySelectorAll('.c-swiper-guide .swiper-slide');
    if (slides.length > 1) {
      swiper = new Swiper('.c-swiper-guide', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: '.c-swiper-guide-nav',
          clickable: true,
        },
      });
    }
  }
}
